import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { CUSTOMER_EVIDENCE } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';

/** Published customer quotes that apply to this workflow. Renders nothing when none apply. */
export function SolutionProof({
  organizations
}: {
  organizations?: string[];
}) {
  const quotes = CUSTOMER_EVIDENCE.filter(item => organizations?.includes(item.organization));
  if (!quotes.length) return null;
  return <section aria-labelledby="solution-proof-heading" className="border-b border-hairline-soft bg-surface" data-id="element-1360" data-mp="zuw2s71yzrt1">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-16 sm:px-6 lg:px-8 lg:py-20" data-id="element-1361" data-mp="v3e1fhw1bp7j">
        <SectionHeading eyebrow="From our customers" headingId="solution-proof-heading" title="Teams already running this workflow." data-id="element-1362" data-mp="q64dk6oanllt" />
        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-1363" data-mp="1nm1fidcm63z4">
          {quotes.map((item, index) => <Reveal key={item.organization} as="li" delay={index * 0.05} className="flex flex-col rounded-2xl border border-hairline bg-panel p-6" data-id="element-1364" data-mp="1isp6hbkf45rh" data-mpi={index}>
              <QuoteIcon className="h-5 w-5 text-lime" aria-hidden="true" data-id="element-1365" data-mp="ui5ijav4nx0j" />
              <blockquote className="mt-4 text-[15px] leading-relaxed text-text-primary" data-id="element-1366" data-mp="gq8vvmc8afbj">“{item.quote}”</blockquote>
              <p className="mt-5 text-sm font-semibold text-text-primary" data-id="element-1367" data-mp="lp27f97yfw92">
                {item.person}, {item.role}
              </p>
              <p className="text-xs text-text-tertiary" data-id="element-1368" data-mp="6r9xqxp3a22s">
                {item.organization} · {item.relationship}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}